
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm-1 5.5v4.158c.002.33.042.585.119.767.076.182.237.403.483.663l1.962 1.918c.504.452.98.446 1.427-.019.448-.464.454-.91.02-1.336L13 11.655V7.5c0-.667-.333-1-1-1s-1 .333-1 1z","fill":"#F7936F"}})])
          )
        }
      }
    